export default function extension(filename = "") {
  const segs = filename.split(".");
  if (segs.length > 1) return segs.slice(-1)[0].toLowerCase();
  return "";
}
